export default __webpack_public_path__ + "static/media/logo.2f90f516.png";